module.exports = __webpack_public_path__ + "media/img/home/gallery/gallery4-fbd467c88d8e6c444f3c18321ffeea11.png";